module.exports = __webpack_public_path__ + "img/famille.9cac8663.jpg";